// due to issue, toast is placed to both layout and each dialog. so this is for shared config.

/** @type {import('@zerodevx/svelte-toast').SvelteToastOptions} */
export const toastOptions = {
	reversed: true,
	// default size
	theme: {
		'--toastWidth': '24rem'
	}
	// intro: { y: 192 }
};

export const toastThemes = {
	success: {
		...toastOptions.theme,
		'--toastBackground': 'oklch(var(--su))',
		'--toastColor': 'oklch(var(--suc))'
	},
	error: {
		...toastOptions.theme,
		'--toastBackground': 'oklch(var(--er))',
		'--toastColor': 'oklch(var(--erc))'
	},
	info: {
		...toastOptions.theme,
		'--toastBackground': 'oklch(var(--in))',
		'--toastColor': 'oklch(var(--inc))'
	},
	warning: {
		...toastOptions.theme,
		'--toastBackground': 'oklch(var(--wa))',
		'--toastColor': 'oklch(var(--wac))'
	}
};
